<template>
    <div class="modal fade" id="updatePersonModal" role="dialog" aria-labelledby="updatePersonModalLabel" backdrop="static" data-backdrop="static" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 class="modal-title" id="updatePersonModalLabel">{{$t('person.edit')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <person-edit-card v-model="model"
                                      v-if="showEditor"
                                      :show-en-names="showEnNames"
                                      @save="onSave"
                                      @cancel="onCancel">
                    </person-edit-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Person } from '../../models/models';
    import PersonEditCard from './PersonEditCard';

    export default {
        components: {
            PersonEditCard
        },
        props: {
            value: {
                type: Object,
                required: false
            },
            show: {
                type: Boolean,
                default: false
            },
            profileManagement: {
                type: Boolean,
                default: false
            },
            showEnNames: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                showEditor: false,
                model: new Person(),
            };
        },
        methods: {
            onClose() {
                this.$emit('onClose', { ...this.model });
                this.model = new Person();
                this.$validator.reset();
                this.showEditor = false;
            },
            hide() {
                $(this.$el).modal('hide');
            },
            onSave(model) {
                this.$emit('onSave', model);
                this.onClose();
            },
            onCancel() {
                this.onClose();
            }
        },
        mounted() {
            // add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            // remove listener
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.model = new Person(this.value);
                    this.model.profileManagement = this.profileManagement;
                    this.showEditor = true;
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px !important;
    }
</style>
